import {getFunctions, httpsCallable} from 'firebase/functions';

const getCallable = (name: string) => httpsCallable(getFunctions(), name);

export const callGptChat = async ({
  model,
  messages,
  temperature = undefined,
}) => {
  try {
    const response = await getCallable('callGPTChat')({
      model: model,
      messages: messages,
      temperature: temperature,
    });
    console.log(response.data);
    return response.data;
  } catch (e) {
    console.log(e);
    return '';
  }
};

export const buildGptChatMessages = (systemPrompt, userPrompt) => {
  return [
    {role: 'system', content: systemPrompt},
    {role: 'user', content: userPrompt},
  ];
};

export const callStyleFeedbackRequest = async (
  messages,
  loggingLocation,
  loggingType,
  pathToProjectFeedbackRequests,
  model = 'gpt-4.1',
) => {
  const response = await getCallable('styleFeedbackRequest')({
    messages: messages,
    model: model,
    loggingLocation: loggingLocation,
    loggingType: loggingType,
    pathToProjectFeedbackRequests: pathToProjectFeedbackRequests,
  });
  return response.data;
};

export const callGptAutograder = async callParams => {
  const {assnId, userId, courseId, studentCode} = callParams;
  const response = await getCallable('autograderRequest')({
    assnId,
    userId,
    courseId,
    studentCode,
  });
  return response.data;
};
